import { render } from "./BindBox.vue?vue&type=template&id=468cbd24"
import script from "./BindBox.vue?vue&type=script&lang=js"
export * from "./BindBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__